import { useEffect, useState } from 'react';
import useChat from './useChat';
import { ensureINSToken, handleFailedRefresh } from '../../services/interactiveServiceFetch';

const useAuthedChat = ({ runPath, sessionType, contextEnv, isViewingConversation = true }) => {
    const [authLoading, setAuthLoading] = useState(true);
    const [authError, setAuthError] = useState(false);

    useEffect(() => {
        ensureINSToken()
            .then(result => {
                if (result.ok) return;
                handleFailedRefresh(result);
                setAuthError(true);
            })
            .finally(() => setAuthLoading(false));
    }, []);

    const chat = useChat({
        runPath,
        sessionType,
        loadSessionsOnMount: !authLoading && !authError,
        contextEnv,
        isViewingConversation,
    });

    return { chat, authLoading, authError };
};

export default useAuthedChat;
